import React, { FC } from 'react';
import classNames from 'classnames';

import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';

import { ideaUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';

import { RankCardFragment } from 'interfaces/graphql-typings';

import styles from './rankCardStyles.scss';

const RankCardIdea: FC<NonNullable<
  | NonNullable<
      NonNullable<NonNullable<NonNullable<RankCardFragment['user']>['topIdeas']>['edges']>[number]
    >['node']
  | NonNullable<NonNullable<RankCardFragment['user']>['recentIdea']>
>> = ({ id, positions, totalReturn }) => {
  if (!positions?.length) return null;

  const redacted = positions[0].primarySymbol === 'Redacted';

  if (redacted)
    return (
      <div className={styles.rankCardIdea}>
        <span className={styles.redactedSymbol}>
          <RedactedDataPoint Wrapper="div" />
        </span>
        <span>
          <ReturnValue value={totalReturn} />
        </span>
      </div>
    );

  return (
    <a
      id={`rank-card-idea-${id}`}
      className={classNames(styles.rankCardIdea, { [styles.isPairTrade]: Boolean(positions[1]) })}
      href={ideaUrl(id)}
    >
      <span className={styles.ellipsis}>
        {separateWithDots(positions.map(position => position.primarySymbol))}
      </span>
      <span>
        <ReturnValue value={totalReturn} />
      </span>
    </a>
  );
};

export default RankCardIdea;
